import { defineComponent as _defineComponent } from 'vue'
import { storeToRefs } from 'pinia';
import CustomChip from '../../components/CustomChip.vue';
import CardMaisFiltros from './CardMaisFiltros.vue';
import { usePublicoParecerReferencialStore } from '../store/PublicoParecerReferencialStore';
import { OPERADORES } from '../../../constants/operadores';
import { SimNao } from '@/types/enum/SimNao';
import { reloadPage } from '@/utils';

interface IOperador {
  operador: string;
  tooltip: string;
  value: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CardParametrosConsulta',
  setup(__props) {

const store = usePublicoParecerReferencialStore();
const { filter } = storeToRefs(store);

const handleClickTermos = (termo: IOperador) => {
  let dePesquisa = filter.value.dePesquisaTermos;

  const { operador } = termo;

  switch (operador) {
    case 'Aspas':
      dePesquisa = dePesquisa ? '"' + dePesquisa + '"' : '""';
      break;
    case 'Interrogacao':
      dePesquisa = dePesquisa ? dePesquisa + '?' : '?';
      break;
    case 'Asterisco':
      dePesquisa = dePesquisa ? dePesquisa + '*' : '*';
      break;
    default:
      dePesquisa = dePesquisa ? `${dePesquisa} ${operador} ` : operador;
  }

  filter.value = {
    ...filter.value,
    dePesquisaTermos: dePesquisa,
  };
};

return { __sfc: true,store, filter, handleClickTermos, CustomChip, CardMaisFiltros, OPERADORES, SimNao, reloadPage }
}

})